module.exports = __webpack_public_path__ + "img/130-sicily.e1b908df.svg";